const defaultState = {
    image: '',
    imageMobile: '',
    visualizerBlockItems: [],
};

export const visualizer = (state = defaultState) => {
    return state;
};
